import * as PIXI from "pixi.js";
/**
 * TweenConstants.ts
 */
export class TweenConstants {
}
TweenConstants.GAME_SUMMARY_DURATION = 3000;
TweenConstants.AVAILABLE_WIN_DELAY_MS = 500;
TweenConstants.AVAILABLE_WIN_SHOW_DURATION = 0.25;
TweenConstants.AVAILABLE_WIN_POPUP_DURATION = 1.5;
TweenConstants.AVAILABLE_WIN_FADE_DURATION = 0.1;
TweenConstants.REEL_STOP_INTERVAL_STANDARD = 200;
TweenConstants.REEL_STOP_INTERVAL_PURCHASE = 200;
TweenConstants.REEL_STOP_INTERVAL_SUSPENSE = 2000;
TweenConstants.BIG_WIN_TITLE_SCALE_DURATION = 0.45;
TweenConstants.FULL_HOUSE_TITLE_SCALE_DURATION = 0.45;
TweenConstants.SCATTER_WIN_TITLE_SCALE_DURATION = 0.45;
TweenConstants.DEFAULT_OVERLAY_FADE_DURATION = 0.25;
TweenConstants.REEL_DURATION = 0.05;
TweenConstants.MOTION_BLUR = new PIXI.Point(0, 50);
TweenConstants.FREE_SPINS_ALPHA = 0.5;
TweenConstants.FREE_SPINS_FLIGHT_DURATION = 0.1;
TweenConstants.FREE_SPINS_INTRO_DURATION = 0.35;
TweenConstants.YOYO_DURATION = 0.25;
//# sourceMappingURL=TweenConstants.js.map